/** Property der Vergleichsobjekte (comparable_details) mit der Entfernung zum Bewertungsobjekt. */
export const COMPARABLE_DISTANCE_PROPERTY = "distance_meters";

/**
 * Property mit der Geokodiergenauigkeit des Vergleichsobjekts (#19461). Wird nicht als eigene Spalte gezeigt,
 * sondern als „±“ an der Entfernung. Ältere AVM-Stände liefern das Feld nicht.
 */
export const COMPARABLE_ACCURACY_PROPERTY = "coordinate_accuracy_meters";

export interface FormattedComparableDistance {
    /** z. B. „786 m“ */
    distance: string;
    /** z. B. „±550 m“, null ohne Genauigkeitsangabe */
    accuracy: string | null;
}

/**
 * Formatiert die Entfernung eines Vergleichsobjekts samt Unsicherheit aus der Koordinatengenauigkeit, wie im Analyst:
 * „786 m ±550 m“. Ganze Meter, da die Geokodierung keine feinere Angabe stützt.
 * @param distance Entfernung in Metern
 * @param accuracy Koordinatengenauigkeit in Metern, null/undefined wenn die AVM sie nicht liefert
 * @param language Sprache für die Zahlformatierung
 * @param unit Einheit, z. B. „m“
 * @return formatierte Teile oder null ohne Entfernung
 */
export function formatComparableDistance(
    distance: number | null | undefined,
    accuracy: number | null | undefined,
    language: string,
    unit = "m",
): FormattedComparableDistance | null {
    if (distance == null) return null;
    const fmt = new Intl.NumberFormat(language, {maximumFractionDigits: 0, useGrouping: true});
    const suffix = unit ? ` ${unit}` : "";
    return {
        distance: fmt.format(distance) + suffix,
        accuracy: accuracy == null ? null : `±${fmt.format(accuracy)}${suffix}`,
    };
}
